import { createContext } from 'react';
import { ProgressTrackerSetting } from '../hooks/progressTracker/useFetchProgressTrackerSettings';
import { ProgressTrackerSettingItemProps } from '../ProgressTrackerSettingItem';
import { TimelineChartOrientation } from '@opengov/stories-shared/types';

export type ProgressTrackerSettingsContextType = {
  progressTrackerSettings: ProgressTrackerSetting[];
  localProgressTrackerSettings: ProgressTrackerSettingItemProps[];
  updateLocalProgressTrackerSettings: (settings: ProgressTrackerSettingItemProps) => void;
  resetLocalProgressTrackerSettings: () => void;
  saveProgressTrackerSettings: () => void;
  hasChanges: boolean;
  showColorModal: boolean;
  setShowColorModal: (showColorModal: boolean) => void;
  activeSettingId: string;
  setActiveSettingId: (settingId: string) => void;
  currentAlignment: TimelineChartOrientation;
  setCurrentAlignment: (alignment: TimelineChartOrientation) => void;
  addNewStatus: () => void;
  isLoading: boolean;
  isDataUpdating: boolean;
};
export const ProgressTrackerSettingsContext = createContext<ProgressTrackerSettingsContextType | undefined>(undefined);
